import React, { useState, useEffect } from 'react';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import Sidebar from '../Components/Sidebar/Sidebar';
import axios from 'axios';

import verificandoToken from '../../FuncoesGerais/VerificarToken';
import verificandoApp from '../../FuncoesGerais/verificaApp';
import { ensureProtocol } from '../../config/backend';
import { fetchGruposUsuarioAtivos } from '../../api/gruposUsuario';

import './novoUsuario.css';

function NovoUsuario(props) {

    const history = useHistory();

    const location = useLocation();
    const { id } = location.state || {};

    const verificar = async () => {
        const resultado = await verificandoApp("ATENDENTE");

        if (!resultado) {
            history.push("/");
        }
    };

    const [usrEml, setUsrEml] = useState('');
    const [usrPwd, setUsrPwd] = useState('');
    const [usrLgn, setUsrLgn] = useState('');
    const [usrGru, setUsrGru] = useState('');
    const [usuSit, setUsuSit] = useState('');
    const [usrAre, setUsrAre] = useState('');
    const [usuSeq, setUsuSeq] = useState('');
    const [perAltUsu, setPerAltUsu] = useState('');
    const [equipex, setEquipex] = useState('');

    const [exec, setExec] = useState('N');

    const [usrConPwd, setUsrConPwd] = useState('');
    const [usrNomCpl, setUsrNomCpl] = useState('');
    const [pesGraImp, setPesGraImp] = useState('');
    const [equitix, setEquitix] = useState('');

    const [placeId, setPlaceId] = useState("Digite sequência do usuário para edição ou deixe em branco para adicionar");
    const [grupos, setGrupos] = useState([]);

    const [objUsu, setObjUsu] = useState();
    const [updIns, setUpdIns] = useState('I');
    const [mensagem, setMensagem] = useState('');
    const [sucesso, setSucesso] = useState('N');

    const verificarCampos = async () => {

        if (usrNomCpl.trim() === '') {
            setMensagem("Atenção deve ser inserido o nome completo do usuário!")
            return;
        }

        if (usrEml.trim() === '') {
            setMensagem("Atenção deve ser inserido e-mail válido!");
            return;
        }

        if (updIns === 'I') {
            if (usrPwd.trim() === '') {
                setMensagem("Atenção deve ser inserida uma senha!");
                return;
            }
        }
        if ((usrPwd.trim() || usrConPwd.trim()) && usrPwd !== usrConPwd) {
            setMensagem("Atenção as senhas não são correspondentes!");
            return;
        }

        if (usrGru === '') {
            setMensagem("Selecione um grupo!");
            return;
        } else {
            const grupoSelecionado = grupos.find((g) => g.codigo === usrGru);
            const exigeArea = grupoSelecionado && (grupoSelecionado.papel === 'analista' || grupoSelecionado.papel === 'administrador');
            if (exigeArea) {
                setEquitix("S");
                if (usrAre === "") {
                    setMensagem("Para grupo com papel Analista ou Administrador a área é obrigatória.");
                    return;
                }
            } else {
                setEquitix("N");
                setUsrAre("");
            }
        }

        if (usuSit === '') {
            setMensagem("Selecione uma situação!");
            return;
        }

        if (pesGraImp === "") {
            setPesGraImp('1');
        }

        setMensagem("");
        await montaObjeto();

    };

    const buscandoUsuario = async (codUsu) => {

        verificandoToken();

        if (codUsu) {
            try {

                const token = localStorage.getItem('token');

                const response = await axios.get(ensureProtocol(localStorage.getItem("ipBackend2")) + "/usuarios", {
                    headers: {
                        Authorization: `${token}`
                    },
                    params: {
                        codUsu: codUsu
                    }
                });

                if (response.data.length > 0) {
                    setUpdIns('U');
                    setUsuSeq(response.data[0].USUSEQ);
                    setUsrNomCpl(response.data[0].USRNOMCPL);

                    setUsrPwd('');
                    setUsrConPwd('');
                    setUsrEml(response.data[0].USREML);
                    setUsrLgn(response.data[0].USRLGN);
                    setUsrGru(response.data[0].USRGRU);
                    setUsuSit(response.data[0].USRSIT);
                    setUsrAre(response.data[0].USRARE);
                    setPesGraImp(response.data[0].PESGRAIMP);
                    setEquitix(response.data[0].EQUITIX);
                    setEquipex(response.data[0].EQUIPEX);
                    setPerAltUsu(response.data[0].PERALTUSU);
                } else {
                    setUpdIns('I');
                    setUsuSeq('');
                    setUsrNomCpl('');
                    setUsrPwd('');
                    setUsrConPwd('');
                    setUsrEml('');
                    setUsrLgn('');
                    setUsrGru('');
                    setUsuSit('');
                    setUsrAre('');
                    setPesGraImp('');
                    setEquitix('');
                    setEquipex('');
                    setPerAltUsu('');
                }

            } catch (error) {
                console.error('Erro ao buscar dados:', error);
            }
        }
    };

    const montaObjeto = async () => {
        let listaUsuario = [];

        listaUsuario.push({
            USUSEQ: usuSeq,
            USREML: usrEml,
            USRPWD: usrPwd,
            USRNOMCPL: usrNomCpl,
            USRLGN: usrLgn,
            USRGRU: usrGru,
            USRSIT: usuSit,
            USRARE: usrAre,
            PESGRAIMP: pesGraImp,
            EQUITIX: equitix,
            EQUIPEX: equipex,
            PERALTUSU: perAltUsu
        })

        setObjUsu(listaUsuario[0]);
    };

    useEffect(() => {
        (async () => {
            const list = await fetchGruposUsuarioAtivos();
            setGrupos(list);
        })();
    }, []);
    useEffect(() => {

        verificar();

        if (id && exec === 'N') {
            setPlaceId(id);
            setUsuSeq(id);
            buscandoUsuario(id);
            setExec('S');
        }
        montaObjeto();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [usrEml, usrPwd, usrNomCpl, usrLgn, usrGru, usuSit, usrAre, pesGraImp, equitix, usuSeq, updIns, equipex, perAltUsu]);

    const inserindoUsuario = async () => {

        verificarCampos();
        verificandoToken();

        const token = localStorage.getItem('token');

        try {
            if (updIns === 'I') {
                await axios.post(ensureProtocol(localStorage.getItem("ipBackend2")) + "/usuarios",
                    objUsu,
                    {
                        headers: {
                            Authorization: `${token}`
                        }
                    });
            } else {

                await axios.put(ensureProtocol(localStorage.getItem("ipBackend2")) + "/usuarios/completo",
                    objUsu,
                    {
                        headers: {
                            Authorization: `${token}`
                        }
                    });

            }
            setMensagem('');
            setSucesso('S');
        } catch (error) {
            setMensagem('Erro ao inserir/atualizar dados');
            setSucesso('N');
        }
    };

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
            <div className="container-fluid titulo">
            <div className="col-4">
                <h1>{updIns === 'U' ? "Alterar" : "Cadastrar"} Usuário</h1>
            </div>
            <form>
                <div className="form-group mb-1">
                    <label for="exampleInputEmail1">Sequência Usuário</label>
                    <input type="email" onChange={(e) => buscandoUsuario(e.target.value)} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder={placeId} />
                </div>
                <div className="form-group mb-1">
                    <label for="exampleInputEmail1">Nome Completo</label>
                    <input type="email" onChange={(e) => setUsrNomCpl(e.target.value)} value={usrNomCpl} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Nome Completo" />
                </div>
                <div className="form-group mb-1">
                    <label for="exampleInputEmail1">Login</label>
                    <input type="email" onChange={(e) => setUsrLgn(e.target.value)} value={usrLgn} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Usuário Sistema " />
                </div>
                <div className="form-group mb-1">
                    <label for="exampleInputEmail1">Endereço de email</label>
                    <input type="email" onChange={(e) => setUsrEml(e.target.value)} value={usrEml} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="E-mail usuário" />
                </div>
                <div className='form-group mt-2 mb-1'>

                </div>
                <div className="form-row mb-1 senhas row">
                    <div className="form-group col">
                        <label for="exampleInputPassword1" className="col">Senha {updIns === 'U' && '(deixe em branco para não alterar)'}</label>
                        <input type="password" onChange={(e) => setUsrPwd(e.target.value)} value={usrPwd} className="form-control col" id="exampleInputPassword1" placeholder={updIns === 'U' ? 'Nova senha (opcional)' : 'Senha'} />
                    </div>
                    <div className="form-group col">
                        <label for="exampleInputPassword1" className="col">Confirme Senha</label>
                        <input type="password" onChange={(e) => setUsrConPwd(e.target.value)} value={usrConPwd} className="form-control col" id="exampleInputPassword1" placeholder={updIns === 'U' ? 'Repita a nova senha' : 'Confirme a Senha'} />
                    </div>
                    <div className="form-group col">
                        <label for="inputEstado">Pode Alterar Solicitante</label>
                        <select id="inputEstado" className="form-control" value={perAltUsu} onChange={(e) => { setPerAltUsu(e.target.value) }}>
                            <option selected>Escolher...</option>
                            <option value={"S"}>Sim</option>
                            <option value={"N"}>Não</option>
                        </select>
                    </div>
                </div>
                <div className="form-row row mb-1">
                    <div className="form-group col">
                        <label for="inputEstado">Grupo</label>
                        <select id="inputEstado" className="form-control" value={usrGru} onChange={(e) => { setUsrGru(e.target.value) }}>
                            <option value="">Escolher...</option>
                            {grupos.map((g) => <option key={g.id} value={g.codigo}>{g.nome}</option>)}
                        </select>
                    </div>
                    <div className="form-group col">
                        <label for="inputEstado">Situação</label>
                        <select id="inputEstado" className="form-control" value={usuSit} onChange={(e) => { setUsuSit(e.target.value) }}>
                            <option selected>Escolher...</option>
                            <option value={"A"}>Ativo</option>
                            <option value={"I"}>Inativo</option>
                        </select>
                    </div>
                    <div className="form-group col">
                        <label for="inputEstado">Área</label>
                        <select id="inputEstado" className="form-control" value={usrAre} onChange={(e) => { setUsrAre(e.target.value); setEquitix("S") }}>
                            <option selected>Escolher...</option>
                            <option value={"S"}>Sistema</option>
                            <option value={"I"}>Infraestrutura</option>
                        </select>
                    </div>
                </div>
                <div className="form-group mb-1">
                    <label for="exampleInputEmail1">Importância de Peso em Prioridades</label>
                    <input type="email" onChange={(e) => setPesGraImp(e.target.value)} value={pesGraImp} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Peso grau de importância de 1 até 10" />
                </div>
                <div className="form-group mb-1">
                    <label for="exampleInputEmail1">Equipe para visualização dos chamados</label>
                    <input type="email" onChange={(e) => setEquipex(e.target.value)} value={equipex} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Equipe de visualização do chamado" />
                </div>
                <button onClick={inserindoUsuario} type="button" className="btn btn-secondary btn-acao mt-4">Salvar</button>
            </form>

            {mensagem.length > 0 ? <div className="alert alert-danger mt-2" role="alert">{mensagem}</div> : null}
            {sucesso === 'S' ? <Redirect to='/home' /> : null}
            </div>
            </main>
        </div>
    );
}

export default NovoUsuario;
